<script setup lang="ts">
defineOptions({
  name: 'TransferMethodCard',
})

import { ref } from 'vue'
import { toggleTransferMethodActivationAction } from '@/api/functions/settings/transfer-method-actions'
import type { TransferMethodItem } from '@/api/typings/settings.typing'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'

const props = defineProps<{
  method: TransferMethodItem
}>()

const emit = defineEmits<{
  updated: []
  edit: [method: TransferMethodItem]
}>()

const toast = useToast()
const isSubmitting = ref(false)

const isActive = () => props.method.status === 'ACTIVE'

const toggleActivation = async () => {
  isSubmitting.value = true
  try {
    const response = await toggleTransferMethodActivationAction(props.method.id, { activation: !isActive() })
    toast.success(response?.meta?.message)
    emit('updated')
  } catch (error) {
    toast.error(getErrorMessage(error), 'خطا')
  } finally {
    isSubmitting.value = false
  }
}
</script>

<template>
  <div class="bg-white rounded-xl p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
    <div class="flex flex-col sm:flex-row sm:items-center gap-3 w-full sm:w-auto">
      <span class="w-fit shrink-0 px-3 py-1 rounded-lg text-[12px] font-medium"
        :class="isActive() ? 'bg-[#d5ddea] text-[#2d5396]' : 'bg-[#fbe4e8] text-[#ed145b]'">
        {{ isActive() ? 'فعال' : 'غیرفعال' }}
      </span>

      <div>
        <p class="text-[#1b325a] font-medium">{{ method.label }}</p>
        <p class="text-[#8a8a8a] text-[12px]">{{ method.title }}</p>
      </div>
    </div>

    <div class="flex items-center gap-2 shrink-0">
      <Button :is-admin="true" variant="outline" :disabled="isSubmitting"
        class="rounded-[10px]! px-5! h-10! py-0 text-[13px] font-normal" @click="emit('edit', method)">
        ویرایش
      </Button>

      <Button :is-admin="true" :variant="isActive() ? 'outline' : 'filled'" :loading="isSubmitting"
        class="rounded-[10px]! px-5! h-10! py-0 text-[13px] font-normal" @click="toggleActivation">
        {{ isActive() ? 'غیرفعال کردن' : 'فعال کردن' }}
      </Button>
    </div>
  </div>
</template>
